<template>
  <div class="tradeModel">
    <div class="layout">
      <div class="money">
        <ul>
          <li><p>交易总手数</p><span v-if="trade.total">{{ parseFloat(trade.total.tradeVolume).toFixed(2) }}手</span></li>
        </ul>
      </div>
      <div class="reportTit">
        <p>共计{{ trade.totalSize }}条记录</p>
        <span @click="selectBrush">筛选<img src="@/assets/images/template/SX.png"></span>
      </div>
    </div>
    <div v-if="trade.recordList" class="reportList">
      <ul v-if="trade.recordList.length>0">
        <li v-for="item in trade.recordList" @click="selectTradePro(item)">
          <div class="item">
            <span>{{ item.displayName }}<em>#{{ item.dealId }}</em></span>
            <em>{{ timeZone(item.exectime) }}</em>
          </div>
          <div class="item">
            <div class="flexStart"><p>{{ item.orderTypeStr }}成交</p><p>{{ item.reportType }}{{ item.direction }}</p><p>{{ item.execvolume }}手</p></div>
            <div class="flexEnd"><p class="color">{{ item.reportType }}价</p><p>{{ item.tradePriceStr }}</p></div>
          </div>
        </li>
      </ul>
      <noData v-else />
    </div>
    <!--交易详情-->
    <div v-if="isShowTrade" class="popFixed">
      <div class="masking" @click="closeTradePop" />
      <div class="tcCon">
        <div class="holdBank between">
          <div class="item">
            <span>交易详情</span>
            <ul id="scroll">
              <li><span>时间</span><span>{{ timeZone(exectime) }}</span></li>
              <li><span>成交号</span><span>{{ dealId?"#":'' }}{{ dealId }}</span></li>
              <li><span>产品</span><span>{{ displayName }}</span></li>
              <li><span>类型</span><span>{{ orderTypeStr }}</span></li>
              <li><span>类别</span><span>{{ reportType }}</span></li>
              <li><span>方向</span><span>{{ direction }}</span></li>
              <li><span>手数</span><span>{{ execvolume }}</span></li>
              <li><span>成交价</span><span>{{ tradePriceStr }}</span></li>
              <li><span>佣金</span><span>{{ commission }}</span></li>
              <li><span>持仓号</span><span>{{ positionId?"#":'' }}{{ positionId }}</span></li>
              <li><span>备注</span><span>{{ remark }}</span></li>
            </ul>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="closeTradePop">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import utils from '@/utils/tradeDataUtil'
export default {
  name: 'TradeRecord',
  components: { noData },
  props: ['trade', 'isBrushTradePop'],
  data() {
    return {
      isShowTrade: false,
      exectime: '',
      dealId: '',
      displayName: '',
      orderTypeStr: '',
      reportType: '',
      direction: '',
      execvolume: '',
      tradePriceStr: '',
      commission: '',
      positionId: '',
      remark: '',
      scrollHeight: '',
      timeZones: this.$route.query.timeZones || ('GMT+8')
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    removeStyle() {
      const main = document.getElementById('main')
      main.removeAttribute('style')
      window.scrollTo(0, this.scrollHeight)
    },
    addStyle() {
      const main = document.getElementById('main')
      let top, body, css
      if (document.documentElement) {
        body = document.documentElement
      } else if (document.body) {
        body = document.body
      }
      if (body.scrollTop) {
        top = body.scrollTop
      } else if (window.pageYOffset) {
        top = window.pageYOffset
      }
      css = 'width: 100%; height: 100%; position: fixed; top: -' + top + 'px;left: 0;'
      main.style.cssText = css
      this.scrollHeight = top
    },
    timeZone(val) {
      if (!val) return ''
      if (val) {
        const localTime = utils.getLocalTime(Number(this.timeZones.substr(3)), val)
        return new Date(localTime).format('Y-MM-dd hh:mm:ss')
      }
    },
    closeTradePop() {
      this.removeStyle()
      this.isShowTrade = false
    },
    selectTradePro(data) {
      this.addStyle()
      this.isShowTrade = !this.isShowTrade
      this.exectime = data.exectime
      this.dealId = data.dealId
      this.displayName = data.displayName
      this.orderTypeStr = data.orderTypeStr
      this.reportType = data.reportType
      this.direction = data.direction
      this.execvolume = data.execvolume
      this.tradePriceStr = data.tradePriceStr
      this.commission = data.commission
      this.positionId = data.positionId
      this.remark = data.remark
    },
    selectBrush() {
      this.toggleFixed()
      let isShowTradeType = this.isBrushTradePop
      isShowTradeType = !isShowTradeType
      this.$emit('blushPop', isShowTradeType)
    }
  }
}
</script>
